import { render, staticRenderFns } from "./card01.vue?vue&type=template&id=6118d724&scoped=true"
import script from "./card01.vue?vue&type=script&lang=js"
export * from "./card01.vue?vue&type=script&lang=js"
import style0 from "./card01.vue?vue&type=style&index=0&id=6118d724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6118d724",
  null
  
)

export default component.exports